import { getDataMapper, mapField, mapArray } from "@/shared";

import { rentStatuses } from "@/entities/rents";

const toHex = (n) => n.toString(16).padStart(2, "0");

const lightenHex = (hex, amount = 0.85) => {
    if (!hex || !hex.startsWith("#")) return hex;

    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const lr = Math.round(r + (255 - r) * amount);
    const lg = Math.round(g + (255 - g) * amount);
    const lb = Math.round(b + (255 - b) * amount);

    return `#${toHex(lr)}${toHex(lg)}${toHex(lb)}`;
};

const getRentStatusColor = (statusConst) => rentStatuses[statusConst]?.color;

const getCalendarBorderColor = (statusConst) => {
    const color = getRentStatusColor(statusConst);

    if (!color || !color.startsWith("#")) return color;

    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);

    return (r + g + b) / 3 > 200 ? "#9ca3af" : color;
};

export const mapCalendarEventFromServer = getDataMapper({
    id: mapField("rent_id"),
    title: mapField("inventory_title"),
    start: mapField("time_start"),
    end: mapField("time_end"),
    rentStateId: mapField("rent_state_id", Number),
    rentStateConst: mapField("rent_state_const"),
    backgroundColor: mapField("rent_state_const", (c) =>
        lightenHex(getCalendarBorderColor(c))
    ),
    borderColor: mapField("rent_state_const", getCalendarBorderColor),
    textColor: mapField("rent_state_const", () => "#111827"),
});

export const mapCalendarEventsFromServer = mapArray(mapCalendarEventFromServer);
